import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  gap: 40px;

  > div {
    width: 100%;
    max-width: 800px;
  }
`;
